import { render, staticRenderFns } from "./QAvatarGroup.vue?vue&type=template&id=5325a155&scoped=true"
import script from "./QAvatarGroup.vue?vue&type=script&lang=js"
export * from "./QAvatarGroup.vue?vue&type=script&lang=js"
import style0 from "./QAvatarGroup.vue?vue&type=style&index=0&id=5325a155&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5325a155",
  null
  
)

export default component.exports